import { FC, useMemo } from 'react';
import { useQuery } from 'react-query';
import { QueryKey } from '@/lib/query-client';
import { getAllProviders } from '@/lib/services/context-provider.service';
import OnOffList from '../on-off-list';
import { FormProps } from '../helpers';
import { DatasourceEntity } from '@/lib/models/policy-model/portal';
import { PolicyModel } from '@/lib/models/policy-model/policy.model';

interface Props extends FormProps {
  value: DatasourceEntity[] | undefined;
  onChange: (access: DatasourceEntity[] | undefined) => void;
  policy: PolicyModel;
}

const DatasourceEntityList: FC<Props> = ({ value, onChange, policy, ...rest }) => {
  const query = useQuery([QueryKey.ContextProvidersList], async () => getAllProviders());
  const { data } = query;

  const datasourceOptions = useMemo(() => {
    return (data || []).map(({ id, name }) => ({
      value: id,
      label: name,
    }));
  }, [data]);

  const { isDefault: isDefaultPolicy } = policy;

  return (
    <OnOffList
      {...rest}
      value={value}
      onChange={onChange}
      options={datasourceOptions}
      idField="dataSourceId"
      search
      emptyMessage="No data sources available"
      withNotSet={!isDefaultPolicy}
      defaultValue={isDefaultPolicy ? false : undefined}
    />
  );
};

export default DatasourceEntityList;
